var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "marketing-configure-error-page" }, [
    _c("div", { staticClass: "marketing-configure-error-page__header" }, [
      _c(
        "div",
        {
          staticClass: "marketing-configure-error-page__header-logo",
          on: {
            click: function($event) {
              return _vm.goToUrl("/home")
            }
          }
        },
        [_c("CompassLogo", { attrs: { type: "logo", width: 160 } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "marketing-configure-error-page__content" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "marketing-configure-error-page__content-title typographies-display-large"
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Une erreur est survenue")) +
              "\n        "
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "marketing-configure-error-page__content-informations typographies-paragraph-x-large-regular",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t.__("marketing.configure.MarketingConfigureErrorPage.error", {
              br: "<br />"
            })
          )
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "marketing-configure-error-page__content-buttons" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__(
                "marketing.configure.MarketingConfigureErrorPage.retry"
              ),
              size: "large"
            },
            on: {
              click: function($event) {
                return _vm.goToUrl("/marketing/configure")
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "marketing-configure-error-page__content-illustration" },
      [
        _c("img", {
          attrs: { src: "/ressources/logged/img/common/global-issues.svg" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }